export var SkuStatus;
(function (SkuStatus) {
    SkuStatus["APPROVED"] = "APPROVED";
    SkuStatus["NOT_APPROVED"] = "NOT_APPROVED";
    SkuStatus["DELETED"] = "deleted";
})(SkuStatus || (SkuStatus = {}));
//# sourceMappingURL=sku-status.js.map